import React from 'react';

import styles from './styles.module.scss';

import { TLandingHowItWorks } from '@utils/types/landings';

const HowItWorks = (props: TLandingHowItWorks) => {
  const { title, description, items } = props;

  return (
    <div className={styles.howItWorks}>
      <div className={styles.howItWorks__wrapper}>
        <h4 className={styles.howItWorks__title}>{title}</h4>
        <div className={styles.howItWorks__description}>{description}</div>

        <div className={styles.howItWorks__items}>
          {items?.map((i, key) => (
            <div className={styles.item} key={i._key}>
              <div className={styles.item__icon}>{key + 1}</div>
              <div>
                <div className={styles.item__title}>{i.title}</div>
                <div className={styles.item__description}>{i.description}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
